import { default as GettingStartedTemplate } from './GettingStartedTemplate';

const getTemplate = (template, values) => {

    switch(template){
        case 'getting-started':
            return GettingStartedTemplate(values)
        default:
            return null
    }
}

export default getTemplate;